// Imports Angular
import { Compiler } from '@angular/core';
import { Http } from '@angular/http';
import { Logger } from 'angular2-logger/core';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { SessionStorageService } from 'ngx-webstorage';

// Imports DIAN
import { DContextoMuiscaServicio, DContextoMuiscaDesaServicio, DLogger, DLoggerAngular, DSessionStorage } from '@dian/core';
import { DFormularioServicio} from '@dian/api-formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DValidacionesFormularioServicio } from '@dian-cmp/formulario';
import { environment } from './../../environments/environment';

const is_desa = false;

export function loggerFactory (logger:Logger, sessionStorage:SessionStorageService) {
    return new DLoggerAngular(logger, sessionStorage);     
}

export function sessionStorageFactory(sessionStorage:SessionStorageService,logger:DLogger) {
	return new DSessionStorage(sessionStorage,logger);    
}

export function contextoMuiscaFactory (http:Http, cookieService:CookieService, compiler:Compiler, logger:DLogger, dNotificacionServicio:DNotificacionServicio, sessionStorage:DSessionStorage) {
    if (is_desa) {                   
        return new DContextoMuiscaDesaServicio(http, cookieService, compiler, logger, dNotificacionServicio, sessionStorage, true, environment);                   
    } else {
        return new DContextoMuiscaServicio(http, cookieService, compiler, logger, dNotificacionServicio, sessionStorage, true, environment);
    }
}

export function formularioFactory(contextoServicio:DContextoMuiscaServicio) {
    return new DFormularioServicio(contextoServicio);    
}



// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/configuracion/app.factories.ts